// Entry point for the supplier profile page. See react_components.js for documentation.
import LockedModal from 'components/authentication_modals/LockedModal'
import SignInModal from 'components/authentication_modals/SignInModal'
import SignUpModal from 'components/authentication_modals/SignUpModal'
import Base from 'components/supplier_show/Base'
import { mount } from 'packs/config/react_rails'

const components = {
  'authentication_modals/LockedModal': LockedModal,
  'authentication_modals/SignInModal': SignInModal,
  'authentication_modals/SignUpModal': SignUpModal,
  'supplier_show/Base': Base
}

mount(components)
